<template>
    <div class="groessere-vdwF">
        <ul>
            <li>Durch größere Oberfläche</li>
            <li>Bewirken höhere Schmelz-/Siedetemperatur</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'groessere-vdwF',
};
</script>
